const siteTitle: ISiteTitle = {
    title1: 'Aviso oficial de accidente de los ramos de Automóvil',
    title2: 'Conforme a lineamientos de la Ley 733 Ley General de Seguros, Reaseguros y Fianzas, así como la Ley 431 de tránsito y sus reformas.'
}

const txtBack = 'Atrás';
const txtNext = 'Siguiente';
const txtSave = 'Crear trámite';

const lstPageTitle: Array<IPageInfo> = [
    {
        index: 0,
        indexBar: 0,
        title1: '¡Hola! Bienvenido Inspector',
        title2: '(*) Espacios requeridos',
        title3: 'Antes de comenzar, por favor especifique si el servicio de asistencia vial será efectuado',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 1,
        indexBar: 0,
        title1: '¡Hola! Bienvenido Inspector',
        title2: '(*) Espacios requeridos',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 2,
        indexBar: 1,
        title1: 'Datos personales',
        title2: '(*) Espacios requeridos',
        title3: 'Información del cliente Asegurado. Solicitar sus datos de contacto actualizados',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 3,
        indexBar: 2,
        title1: 'Registro del siniestro',
        title2: '(*) Espacios requeridos',
        title3: 'Ingrese toda la información relacionada al siniestro del vehículo asegurado',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 4,
        indexBar: 3,
        title1: 'Daños a terceros',
        title2: '(*) Espacios requeridos',
        title3: 'Ingresa las fotografías de los daños causados a terceros si fuese el caso',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 5,
        indexBar: 4,
        title1: 'Creación del trámite de Reclamo',
        title2: '(*) Espacios requeridos',
        title3: 'Antes de crear tu trámite, el cliente debe tener en cuenta estos puntos:',
        txtBtnBack: txtBack,
        txtBtnNext: txtSave,
    } as IPageInfo,
    {
        index: 6,
        indexBar: 4,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
]

const catEfectuarLevatamiento: Array<ICatalog> = [
    { value: 'S', text: 'Si' } as ICatalog,
    { value: 'N', text: 'No' } as ICatalog
]

const catSiNo: Array<ICatalog> = [
    { value: 'S', text: 'Si' } as ICatalog,
    { value: 'N', text: 'No' } as ICatalog
]

const catMovitoNoServicio: Array<ICatalog> = [
    { value: '1', text: 'Cliente llegó a arreglo con el otro conductor' } as ICatalog,
    { value: '2', text: 'Cliente se movió del lugar' } as ICatalog,
    { value: '3', text: 'Cliente no desea usar el seguro' } as ICatalog,
    { value: '4', text: 'Otro' } as ICatalog
]

const catIdentificationType: Array<ICatalog> = [
    { value: '1', text: 'Cédula' } as ICatalog,
    { value: '2', text: 'Pasaporte' } as ICatalog,
    { value: '3', text: 'Residencia' } as ICatalog,
    { value: '4', text: 'Cédula extranjera' } as ICatalog,
]

const catDamageLevel: Array<ICatalog> = [
    { value: 'L', text: 'Leve' } as ICatalog,
    { value: 'M', text: 'Mediano' } as ICatalog,
    { value: 'F', text: 'Fuerte' } as ICatalog,
]

const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: 0,
            "text-align-last": "left",
            '&:hover': {
                border: '0 !important',
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const enum inspectionStatusEnum {
    recorded = 1,
    process = 2,
    cancelled = 3,
    finished = 4
}

const enum typeFileEnum {
    identificationFrontImage = 1,
    identificationBackImage = 2,
    driverLicenseImage = 3,
    sinisterEnvironmentImage = 4,
    frontVehicleImage = 5,
    backVehicleImage = 6,
    rightVehicleImage = 7,
    leftVehicleImage = 8,
    damageVehicleImage = 9,
    inspectionImage = 10,
    imageDamageDetail = 11,
    signatureImage = 12,
    signatureDriverImage = 13
}

const enum typeFileVehicleInvolvedEnum 
{
    identificationFrontImage = 1,
    identificationBackImage = 2,
    frontVehicleImage = 3,
    backVehicleImage = 4,
    rightVehicleImage =  5,
    leftVehicleImage = 6,
    damageVehicleImage = 7
}

const enum stepEnum {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6
}

export {
    siteTitle,
    lstPageTitle,
    catEfectuarLevatamiento,
    catMovitoNoServicio,
    catSiNo,
    catIdentificationType,
    customStyles,
    catDamageLevel,
    inspectionStatusEnum,
    typeFileEnum,
    stepEnum,
    typeFileVehicleInvolvedEnum
};